import axios from "axios";

// axios.defaults.baseURL = "http://172.16.5.27:7145/";
axios.defaults.baseURL = "https://gogbackendapi.treeone.one/";

global.$axios = axios;
